import { Globe, Building2, Megaphone } from 'lucide-react';

export type NivelOrigen = 'global' | 'nacional' | 'diocesano' | 'local';

export const NIVEL_CONFIG: Record<NivelOrigen, { label: string; badgeClass: string; icon: React.ReactNode; orden: number }> = {
  global: {
    label: 'Internacional',
    badgeClass: 'bg-sky-100 text-sky-700 border border-sky-200',
    icon: <Globe className="w-3.5 h-3.5" />,
    orden: 1,
  },
  nacional: {
    label: 'Nacional',
    badgeClass: 'bg-blue-100 text-blue-700 border border-blue-200',
    icon: <Building2 className="w-3.5 h-3.5" />,
    orden: 2,
  },
  diocesano: {
    label: 'Diocesana',
    badgeClass: 'bg-teal-100 text-teal-700 border border-teal-200',
    icon: <Building2 className="w-3.5 h-3.5" />,
    orden: 3,
  },
  local: {
    label: 'Local',
    badgeClass: 'bg-slate-100 text-slate-600 border border-slate-200',
    icon: <Megaphone className="w-3.5 h-3.5" />,
    orden: 4,
  },
};

export const NIVEL_LABELS: Record<string, string> = {
  global: 'Internacional',
  nacional: 'Nacional',
  diocesano: 'Diocesana',
  local: 'Local',
};
